module.exports = __webpack_public_path__ + "static/fonts/alimamashuhei.98a341c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/alimamashuhei.ttf
// module id = JAko
// module chunks = 45